<div class="tree">
  <div class="search-container" *ngIf="searchable">
    <input
      class="search"
      [(ngModel)]="searchText"
      autocomplete="off"
      (keyup.enter)="search()"
      matInput
      type="text"
      [formControl]="searchControl"
      placeholder="{{ searchPlaceholder }}"
    />
    <span class="fa fa-search" (click)="search()"></span>
  </div>

  <div *ngIf="displaySource.length > 0" class="tree-container">
    <cdk-virtual-scroll-viewport
      class="virtual-scroll-container"
      [style.height.px]="vScrollHeightPx"
      [itemSize]="itemSize"
      [maxBufferPx]="maxBufferPx"
      [minBufferPx]="minBufferPx"
    >
      <ng-container *cdkVirtualFor="let node of displaySource; let i = index; trackBy: trackByFn; templateCacheSize: 0">
        <div class="node" [ngStyle]="{ 'padding-left': node.level * 24 + 'px', 'font-size' : fontSize }">
          <div
            [class.chevron-hidden]="!node.expandable"
            class="fa expand-icon"
            [ngClass]="{ 'fa-chevron-down': isExpanded(node), 'fa-chevron-right': !isExpanded(node) }"
            (click)="toggleExpand(node, i)"
          ></div>

          <mat-checkbox
            *ngIf="node.item.selectable && multiple"
            [disableRipple]="true"
            [checked]="isChecked(node)"
            [disabled]="node.item.disabled"
            [indeterminate]="descendantsPartiallySelected(node)"
            (change)="checkChanged(node, true)"
            >{{ node.item.name }}
          </mat-checkbox>

          <mat-radio-button
            *ngIf="node.item.selectable && !multiple"
            [disableRipple]="true"
            [checked]="isChecked(node)"
            [disabled]="node.item.disabled"
            [name]="radioGroup"
            (change)="checkChanged(node, true)"
            >{{ node.item.name }}
          </mat-radio-button>

          <ng-container *ngIf="!node.item.selectable">
            <div *ngIf="i < initialMaxItems || initialMaxItems === 0; else hiddenItem">
              {{ node.item.name }}
            </div >
            <ng-template #hiddenItem>
              <div *ngIf="isItemHidden" >{{ node.item.name }}</div>
            </ng-template>
          </ng-container>
          <ng-container *ngTemplateOutlet="templateRef; context: { node: node }"></ng-container>
        </div>
      </ng-container>
      <a class="toggle-hidden-list" *ngIf="displaySource.length > initialMaxItems && !isItemHidden && initialMaxItems !== 0" (click)="toggleHiddenList()">
        <span>+ </span>{{ displaySource.length - initialMaxItems }} {{ toggleHiddenListLabel }}
      </a>
    </cdk-virtual-scroll-viewport>
  </div>

  <div *ngIf="displaySource.length <= 0" class="no-result">
    <app-notification-card type="info" text="keine Ergebnisse gefunden"> </app-notification-card>
  </div>
</div>
